import { getObjectValue } from '@services/object-extensions';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import ArrowRightSvg from '@svg/arrow-right.svg';
import styles from './card.module.css';

const Card = ({ translations = {} }) => {
  return (
    <div className="snf-lx-components-servizi-soluzioni-card-card" style={{ display: 'contents' }}>
      <>
        <div className="div-story p-1 p-sm-2 p-lg-2">
          <div className={`${styles.container} story`}>
            <div className="mb-3">
              <div className="snf-font-w6 snf-font-24">
                {getObjectValue(translations, 'title', '')}
              </div>
            </div>
            <p className={`snf-font-19 ${styles.description}`}>
              {getObjectValue(translations, 'text', '')}
            </p>
            <div className="div-button">
              <Link to="/storie-successo">
                <button
                  type="button"
                  className="btn rounded-0 snf-bg-color-denim text-white px-3 snf-font-16 text-uppercase snf-font-w6"
                >
                  <FormattedMessage
                    defaultMessage="Mostra di più"
                    description="Storie di successo / Link"
                  />
                  <span className="ml-3 arrowButton">
                    <ArrowRightSvg />
                  </span>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

Card.displayName = 'Card';
export { Card };
